/**
 * V2 wrapper for Deployments tab. Used by ViewDetailV2 (and future TableDetailV2 / MappingDetailV2).
 * @see NewDeployments — shared implementation used by Table/Mapping details.
 */
import { NewDeployments } from './NewDeployments'

export const NewDeploymentsV2 = () => <NewDeployments />
